import React from 'react'
import './CheckBox.css'

class CheckBox extends React.Component {

    render() {
        return (
            <div>
                <label className="label-nowrap label-text" htmlFor={this.props.id}>
                    <input className="radio-checkbox-nowrap" type="checkbox" id={this.props.id} checked={this.props.checked} name={this.props.name} onChange={this.props.handleChange}/>{this.props.text || this.props.children}
                </label>   
            </div>
        )
    }
}

export default CheckBox